import { render, staticRenderFns } from "./TelegramDiscussion.vue?vue&type=template&id=0a80dec1"
import script from "./TelegramDiscussion.vue?vue&type=script&lang=js"
export * from "./TelegramDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports